module.exports = __webpack_public_path__ + "staticcomp/img/content_1.6e499b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/3/content_1.jpg
// module id = HSVd
// module chunks = 39